import { environment } from 'src/environments/environment';
import { ApiService } from './../api.service';
import { Injectable } from '@angular/core';
import { Observable, of } from'rxjs';
@Injectable({ providedIn: 'root' })
export class FileService {
	fileURL: any;
	constructor(
		private apiService: ApiService,
	) { }
	generatePDF(body) {
		const generatePDFUrl = environment.pdfGenerate + '/generatepdfreports/';
		return this.apiService.post(generatePDFUrl, body);
	}

	getS3SignedURLPublic(fileKey, queryParams?) {
		if (queryParams) {
			const url = environment.documentServiceUrl + '/api/document/v1/signedURL/public?key=' + fileKey + `&${queryParams}`;
			return this.apiService.get(url);
		} else {
			const url = environment.documentServiceUrl + '/api/document/v1/signedURL/public?key=' + fileKey;
			return this.apiService.get(url);
		}

	}

	downloadSpcwedQpExcel(params?) {
		let URL: any;
		if (params) {
			URL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/list?type=Scpwd&scpwdExcel=true&` + params
		} else {
			URL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/list?type=Scpwd&scpwdExcel=true&`;
		}
		return this.apiService.getBlob(URL, 'application/vnd.ms-excel');
	}
	deactiveQPExcelDownload() {
		const url = environment.sqaServiceUrl + '/api/sqa/qp/deactivatedqps?excel=true';
		return this.apiService.getBlob(url, 'application/vnd.ms-excel');
	}

	getImageURL(fileKey, role?) {
		if (fileKey && fileKey.includes('https://s3.ap-south-1.amazonaws.com/nsdc-app')) {
			return of(fileKey)
		}
		console.log("role ========>",role)
        if(!fileKey) {
			return;
		}
		let file_key = fileKey.split("/")
		let imageURL = environment.documentServiceUrl + '/api/document/v1/signedURL?key=' + encodeURIComponent(fileKey);
		if(role === "Candidate" && file_key[0] === "Candidate" || file_key[0] === "candidate"){
			imageURL = environment.documentServiceUrl + `/api/document/v1/signedURL?role=${role}&key=` + encodeURIComponent(fileKey);
		}
		return this.apiService.get(imageURL);
	}

	getImageURLFeebased(fileKey): Observable<any> {
		if (fileKey && fileKey.includes('https://s3.ap-south-1.amazonaws.com/nsdc-app')) {
			return of(fileKey)
		}
		const imageURL = environment.documentServiceUrl + '/api/document/v1/signedURL?key=' + fileKey;
		return this.apiService.get(imageURL);
	}

	previewImage(url?: any,  __filename?) {

		this.fileURL = url;
		if (this.fileURL === undefined) {
			return;
		}
		if (this.fileURL.includes('https://s3.ap-south-1.amazonaws.com/nsdc-app/')
			|| this.fileURL.includes('https://nsdc-app.s3.ap-south-1.amazonaws.com')) {
			this.downloadFromUrl(this.fileURL, __filename);
			return
		}
		const isArr = Array.isArray(this.fileURL);
		if (!isArr) {
			if (this.fileURL.includes('.com/')) {
				this.fileURL = this.fileURL.split('.com/').pop();
			}
			// const documentDOwnloadURL =
			// 	environment.documentServiceUrl +
			// 	'/api/document/v1/signedURL?key=' +
			// 	this.fileURL;
			// this.apiService.get(documentDOwnloadURL).
			this.getImageURL(this.fileURL)
				.subscribe(signedURL => {
					const popupCheck = window.open('');
					if (popupCheck == null || typeof (popupCheck) === 'undefined') {
						alert('Please enable popup to open documents in new tab, Check in right side of browser url bar and allow');
						return true;
					} else {
						// popupCheck.close();

						console.log('FILE URL ', this.fileURL);
						console.log('SIGNED URL ', signedURL);


					}
				});
		} else {
			this.getSignedURLForMultiDownload('');
		}
	}

	downloadAttachedFile(url?: any,  __filename?) {
		this.fileURL = url;
		console.log(this.fileURL, url);
		if (this.fileURL === undefined) {
			console.log('..return..');
			return;
		}
		if (this.fileURL.includes('https://s3.ap-south-1.amazonaws.com/nsdc-app/')
			|| this.fileURL.includes('https://nsdc-app.s3.ap-south-1.amazonaws.com')) {
			this.downloadFromUrl(this.fileURL, __filename);
			return
		}
		const isArr = Array.isArray(this.fileURL);
		if (!isArr) {
			if (this.fileURL.includes('.com/')) {
				this.fileURL = this.fileURL.split('.com/').pop();
			}
			// const documentDOwnloadURL =
			// 	environment.documentServiceUrl +
			// 	'/api/document/v1/signedURL?key=' +
			// 	this.fileURL;
			// this.apiService.get(documentDOwnloadURL).
			this.getImageURL(this.fileURL)
				.subscribe(signedURL => {
					const popupCheck = window.open('');
					if (popupCheck == null || typeof (popupCheck) === 'undefined') {
						alert('Please enable popup to open documents in new tab, Check in right side of browser url bar and allow');
						popupCheck.close()
						return true;
					} else {
						popupCheck.close()
						const a = document.createElement('a');
						console.log(signedURL);
						document.body.appendChild(a);
						a.setAttribute('style', 'display: none');
						a.setAttribute('target', '_blank');
						a.href = signedURL;
						a.download = __filename;
						a.click();
						// window.open(signedURL);
						window.URL.revokeObjectURL(signedURL);
						a.remove();
						return false;
					}
				});
		} else {
			this.getSignedURLForMultiDownload('');
		}
	}
	downloadFromBlob(blob: Blob, fileName: string = '') {
		const url = URL.createObjectURL(blob);
		this.downloadFromUrl(url, fileName);
	}
	downloadFromUrl(signedURL: string, fileName: string = '') {
		const popupCheck = window.open('');
		if (popupCheck == null || typeof (popupCheck) === 'undefined') {
			alert('Please enable popup to open documents in new tab, Check in right side of browser url bar and allow');
			return true;
		} else {
			popupCheck.close();
			const a = document.createElement('a');
			document.body.appendChild(a);
			a.setAttribute('style', 'display: none');
			a.setAttribute('target', '_blank');
			a.href = signedURL;
			a.download = fileName;
			a.click();
			window.URL.revokeObjectURL(signedURL);
			a.remove();
			return false;
		}
	}
	getSignedURLForMultiDownload(__filename) {
		this.fileURL.forEach(element => {
			if (element && element !== null) {
				const documentDOwnloadURL = `${environment.documentServiceUrl}/api/document/v1/signedURL?key=${encodeURIComponent(element)}`
				this.apiService.get(documentDOwnloadURL).subscribe(signedURL => {
					const popupCheck = window.open('');
					if (popupCheck == null || typeof (popupCheck) === 'undefined') {
						alert('Please enable popup to open documents in new tab, Check in right side of browser url bar and allow.');
						return true;
					} else {
						popupCheck.close();
						const a = document.createElement('a');
						document.body.appendChild(a);
						a.setAttribute('style', 'display: none');
						a.setAttribute('target', '_blank');
						a.href = signedURL;
						a.download = __filename;
						a.click();
						window.URL.revokeObjectURL(signedURL);
						a.remove();
						return false;
					}

				});
			}
		});
	}
	getImageURLForCandidate(fileKey) {
		const imageURL = environment.documentServiceUrl + `/api/document/v1/signedURL?key=${fileKey}&role=Candidate`;
		console.log(imageURL);
		return this.apiService.get(imageURL);
	}



	previewPdf(url?: any,  __filename?) {
		this.fileURL = url;
		if (this.fileURL === undefined) {
			return;
		}
		const isArr = Array.isArray(this.fileURL);
		if (!isArr) {
			if (this.fileURL.includes('.com/')) {
				this.fileURL = this.fileURL.split('.com/').pop();
			}
			// const documentDOwnloadURL =
			// 	environment.documentServiceUrl +
			// 	'/api/document/v1/signedURL?key=' +
			// 	this.fileURL;
			// this.apiService.get(documentDOwnloadURL).
			this.getImageURL(this.fileURL)
				.subscribe(signedURL => {
					const popupCheck = window.open('');
					if (popupCheck == null || typeof (popupCheck) === 'undefined') {
						alert('Please enable popup to open documents in new tab, Check in right side of browser url bar and allow');
						return true;
					} else {
						// popupCheck.close();
						console.log(signedURL)
						const a = document.createElement('a');
						document.body.appendChild(a);
						a.setAttribute('style', 'display: none');
						a.setAttribute('target', '_blank');
						a.href = signedURL;
						a.download = __filename;
						a.click();
						// window.open(signedURL);
						window.URL.revokeObjectURL(signedURL);
						a.remove();
						return false;
					}
				});
		} else {
			this.getSignedURLForMultiDownload('');
		}
	}

}

